import { observer } from 'src/utils/mobx-react';
import React, { useState } from 'react';
import { MarketSettingsTab } from 'src/domains/sportsbook/trading/view/eventDetails/markets/MarketSettingsTab';
import { useAppStateContext } from 'src/AppState/AppState';
// eslint-disable-next-line no-restricted-imports
import { useAsObservableSource } from 'mobx-react-lite';
import { EventMarketItemType } from 'src_common/common/websocket2/modelsApi/EventMarkets';
import { List } from 'react-movable';
import { TypeId } from 'src_common/common/websocket2/type';
import styled from '@emotion/styled';
import { EventMarketsItemState } from 'src/domains/sportsbook/trading/view/eventDetails/markets/eventMarketsItem/EventMarketsItem.state';
import { RowMarketItem } from 'src/domains/sportsbook/trading/view/eventDetails/markets/eventMarketsItem/RowMarketItem';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';
import { EventMarketsState } from 'src/domains/sportsbook/trading/view/eventDetails/markets/EventMarkets.state';

const ListElement = styled('li', { label: 'ListElement' })<{ isDragged: boolean }>`
    z-index: 1000;
    width: 100%;
    opacity: ${({ isDragged }): string => (isDragged === true ? '.5' : '1')};
    background: rgba(255, 255, 255, 0.4);
    list-style: none;
    clear: both;
    display: flex;
    flex-wrap: nowrap;
`;

export type EventMarketsItemPropsType = {
    eventId: EventId;
    group: Array<{ market: EventMarketItemType; expanded: boolean; groupName: string }>;
    shortname: string;
    eventMarketsState: EventMarketsState;
};

export const EventMarketsItem = observer('EventMarketsItem', (propsIn: EventMarketsItemPropsType) => {
    const props = useAsObservableSource(propsIn);
    const appState = useAppStateContext();
    const [state] = useState(() => new EventMarketsItemState(props, appState));

    const market = state.groupMarkets[0]?.market;
    if (market === undefined) {
        return null;
    }
    return (
        <div>
            <RowMarketItem
                eventMarketsItemState={state}
                marketId={market.id2}
                toggle={props.eventMarketsState.toggle}
                key={`row-item-${TypeId.getMarketId(market.id)}`}
                shortname={props.shortname}
            />
            {state.isOpenedMainMarket ? (
                <div key={`${props.shortname}-expandable`}>
                    <MarketSettingsTab marketId={state.marketExpanded?.id ?? null} />
                </div>
            ) : null}
            {state.isMarketInnerGroup ? (
                state.openedGroup === true || state.isGroupExpended ? (
                    <div className='group-expanded'>
                        <List
                            lockVertically
                            onChange={state.onSortInnerMarkets}
                            renderList={({ children, props: ListProps, isDragged }) => (
                                <ul
                                    {...ListProps}
                                    className='flex-table'
                                    style={{ cursor: isDragged ? 'grabbing' : 'inherit' }}
                                >
                                    {children}
                                </ul>
                            )}
                            values={state.groupMarkets}
                            renderItem={({ value, props: itemProps, isDragged }) => {
                                const innerMarket = value.market;

                                return (
                                    <ListElement
                                        {...itemProps}
                                        className='event-markets-table-inner rower form'
                                        isDragged={isDragged}
                                    >
                                        <RowMarketItem
                                            eventMarketsItemState={state}
                                            key={`row-item-${TypeId.getMarketId(innerMarket.id)}`}
                                            marketId={innerMarket.id2}
                                            toggle={props.eventMarketsState.toggle}
                                            inner={true}
                                            shortname={props.shortname}
                                        />
                                        {state.getOpenedMarket !== undefined &&
                                        state.getOpenedMarket === innerMarket.id &&
                                        state.marketExpanded !== undefined ? (
                                            <div key={`${props.shortname}-expandable`}>
                                                <MarketSettingsTab marketId={state.marketExpanded.id} />
                                            </div>
                                        ) : null}
                                    </ListElement>
                                );
                            }}
                        />
                    </div>
                ) : null
            ) : null}
        </div>
    );
});
